import {
  CASE_DEPARTMENT_REQUESTED,
  CASE_DEPARTMENT_PROCESSING,
  CASE_DEPARTMENT_SUCCESSED,
  CASE_DEPARTMENT_FAILED,
} from '../../constants/actionTypes';

const initialState = {
  result: {},
  isProcessing: null,
  isSuccess: null,
  hasErrors: null,
};

export const caseMasterDepartment = (state = initialState, action) => {
  switch (action.type) {
    case CASE_DEPARTMENT_REQUESTED: {
      return {
        ...state,
        error: null,
        loading: true,
        requested: true,
      };
    }
    case CASE_DEPARTMENT_PROCESSING: {
      return {
        ...state,
        error: null,
        loading: true,
        requested: false,
      };
    }
    case CASE_DEPARTMENT_SUCCESSED: {
      return {
        ...state,
        result: action.data,
        error: null,
        loading: false,
        requested: false,
      };
    }
    case CASE_DEPARTMENT_FAILED: {
      return {
        ...state,
        result: {},
        error: action.data,
        loading: false,
        requested: false,
      };
    }

    default: {
      return {
        ...state,
      };
    }
  }
};

export default caseMasterDepartment;

